/**
 * state extension for store module
 */
export const state = {
  providers: {},      // registry for all providers
  heartbeats: {}      // registry for all heartbeats
}